<div data-cy="adacode-config-title">
  ADA Codes
</div>



<div class="layout_row" data-cy="adacode-config-layout">
  <div class="layout_columnL" style="background-color: #00B5FB;" data-cy="adacode-config-column-left">
    <h2 data-cy="adacode-config-list-title">ADA Codes</h2>
    <dx-list style="background-color: white;"
      [dataSource]="listOfCodes"
             [disabled]="!isDataEditDissabled"
       itemTemplate="listItem"
             selectionMode="single"
             height="500"
             (onItemClick)="onCodeItemClock($event)"
             data-cy="adacode-config-list"
    >

      <div *dxTemplate="let item of 'listItem'" data-cy="adacode-config-list-item">
        <div data-cy="adacode-config-list-item-code">{{item.Code}}</div>
      </div>


    </dx-list>
  </div>
  <div class="layout_columnR" style="background-color:white;" data-cy="adacode-config-column-right">
    <h2 data-cy="adacode-config-form-title">Configure ADA Codes</h2>
    <dx-button text="New" id="btnNew" [visible]="isNewVisible" (onClick)="onButtonActioClick($event)" data-cy="adacode-config-new-btn"></dx-button>
    <dx-button text="Edit" id="btnEdit" [visible]="isEditVisible" (onClick)="onButtonActioClick($event)" data-cy="adacode-config-edit-btn"></dx-button>
    <dx-button text="Save" id="btnSave" [visible]="isSaveVisible" (onClick)="onButtonActioClick($event)" data-cy="adacode-config-save-btn"></dx-button>
    <dx-button text="Cancel" id="btnCancel" [visible]="isCancelVisible" (onClick)="onButtonActioClick($event)" data-cy="adacode-config-cancel-btn"></dx-button>

    <div style="margin-top: 10px;" data-cy="adacode-config-form">
      <table data-cy="adacode-config-table">
        <tr data-cy="adacode-config-code-row">
          <td data-cy="adacode-config-code-cell">
            <dx-text-box label="Code:" labelMode="float" [(ngModel)]="selectedRowData.Code" [inputAttr]="{ 'style':  'text-transform: uppercase'}" [disabled]="isDataEditDissabled" data-cy="adacode-config-code-input"></dx-text-box>
          </td>
        </tr>

        <tr data-cy="adacode-config-surface-row">
          <td data-cy="adacode-config-surface-cell">
            <dx-check-box [(value)]="selectedRowData.isNeedsSurface" (onValueChanged)="onValueChanged($event)" text="Need surface" [disabled]="isDataEditDissabled" data-cy="adacode-config-surface-checkbox"></dx-check-box>
          </td>
        </tr>
        <tr data-cy="adacode-config-narrative-row">
          <td data-cy="adacode-config-narrative-cell">
            <dx-check-box [(value)]="selectedRowData.isNeedsNarrative" (onValueChanged)="onValueChanged($event)" text="Need Narrative" [disabled]="isDataEditDissabled" data-cy="adacode-config-narrative-checkbox"></dx-check-box>
          </td>
        </tr>
        <tr data-cy="adacode-config-xray-row">
            <td data-cy="adacode-config-xray-cell">
              <dx-check-box [(value)]="selectedRowData.isNeedsXray" (onValueChanged)="onValueChanged($event)" text="Need Xray" [disabled]="isDataEditDissabled" data-cy="adacode-config-xray-checkbox"></dx-check-box>
            </td>
        </tr>


      </table>

    </div>


  </div>
</div>


